/* eslint-disable */

import Navbar from "../../../components/NavbarCustomer";
import VenueStayPreview from "../../../components/venueStayPreview/VenueStayPreview";
import { useParams, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { base_URL } from "../../../config/config";
import { DeviceType } from "../../../hooks/deviceType";
import axios from "axios";
import { useEffect } from "react";

const Preview = ({ filters, setFilters }) => {
  const deviceType = DeviceType();
  const user = localStorage.getItem("authUser");
  const { id, cf, slug } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const breadcrumbRaw = searchParams.get("breadcrumbPath");
  const breadcrumbPathParam = breadcrumbRaw
    ? JSON.parse(decodeURIComponent(breadcrumbRaw))
    : [];

  const stateCrumbs = location.state?.breadcrumbPath || breadcrumbPathParam;
  const favoriteVenuesAndStay =
    user?.favoritesFolder?.map((folder) => folder.venuesAndStay).flat() || [];

  const { data, isError, error } = useQuery({
    queryKey: ["previewData", id], // Key for caching
    queryFn: async () => {
      if (!id) throw new Error("ID is required");
      const response = await axios.post(
        `${base_URL}/api/hotels/get-preview-hotels`,
        {
          id,
        }
      );

      if (response.status !== 200) {
        throw new Error(`Failed to fetch preview data: ${response.statusText}`);
      }

      return response.data; // Axios automatically parses JSON
    },
    enabled: !!id, // Enable query only when `id` is available
  });


  const decodeSlug = (slug) => {
    if (!slug) return "";
    return slug
      .replace(/-/g, " ") // replace hyphens with spaces
      .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word
  };

  const breadcrumbPath =  (stateCrumbs && stateCrumbs.length > 0) ? stateCrumbs : [
    { name: "Home", to: "/" },
    { name: "Venues with Rooms", to: "/listing/2" },
    {
      name: decodeSlug(slug),
      to: "",
    },
  ];
  const isFavorite =
    data && favoriteVenuesAndStay.some((favorite) => favorite?.id === id);

  const updatePageVisits = async (userId, vendorId, venueName) => {
    const pageVisitData = {
      venueId: id,
      venueName: venueName,
      date: new Date(),
      vendorId: vendorId,
      deviceCategory: deviceType,
      customerId: userId,
      pageVisits: 1,
      isFav: isFavorite,
    };
    // console.log(pageVisitData);
    try {
      const response = await fetch(
        `${base_URL}/api/impressions/update-impressions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(pageVisitData),
        }
      );
      // console.log(response);
      const data = await response.json();
      // console.log(data);
      return data;
    } catch (err) {
      // console.log(err);
      return err;
    }
  };

  useEffect(() => {
    if (data && cf === "hpv") {
      // console.log("Data inside Preview Component", data);
      const venueName = data?.venue?.basicDetails?.hotelName;
      const vendorId = data?.venue?.vendorId;
      if (!user) {
        updatePageVisits("guest", vendorId, venueName);
      } else if (user?._id && vendorId && venueName) {
        updatePageVisits(user?._id, vendorId, venueName);
      }
    }
  }, [data]);

  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <Navbar filters={filters} setFilters={setFilters} />
      {data && (
        <VenueStayPreview
          previewData={data.venue}
          breadcrumbPath={breadcrumbPath}
        />
      )}
    </div>
  );
};

export default Preview;
